import { CheckoutMetaDataType as n } from "@ancon/wildcat-types";
import f from "./isWalletTopUpCheckoutItem.mjs";
function o(t) {
  var e, i;
  const r = (e = t == null ? void 0 : t.items) == null ? void 0 : e.find(f);
  if (r) {
    const a = (i = t == null ? void 0 : t.metaData) == null ? void 0 : i.find(
      ({ checkoutItemId: p, metaDataType: m }) => p === r.id && m === n.Wallet
    );
    return a == null ? void 0 : a.metaData;
  }
}
export {
  o as default
};
